// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"681":"93cc5207","851":"93cc5207","990":"c283a195"}[chunkId] + ".chunk.css";
};